// @ts-nocheck fddff96e
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_progressBar'],
      sections: [addPanel.sections.getSections().developer.progressBarSection],
    };
  },
};
